import React, { useState } from 'react';
import { Modal, Select, Button } from 'antd';

interface ShowModalProps {
    show: boolean,
    toggleShow: () => void,
    setYear: React.Dispatch<React.SetStateAction<string>>,
    years: number[],
    isCreate: boolean,
    qtdYearsMinus: number
}

const ModalSelectYear = ({ show, toggleShow, setYear, years, isCreate, qtdYearsMinus}: ShowModalProps) => {
    const [tempYear, setTempYear] = useState("");
    const handleClose = () => toggleShow();

    const handleChooseClose = () => {
        setYear(tempYear);
        setTempYear("");
        toggleShow();
    }

    const itens = () => {
        let items: JSX.Element[] = [];
        let yearNow: number = new Date().getFullYear();
        for (let i = (yearNow - qtdYearsMinus); i <= yearNow; i++) {
            if (isCreate && !years.includes(i)) {
                items.push(<option key={i} value={i}>{i}</option>);
            } else if (!isCreate && years.includes(i)) {
                items.push(<option key={i} value={i}>{i}</option>);
            }
        }
        return items;
    }
    return (
        <Modal
            title="Selecione um ano"
            visible={show}
            onCancel={toggleShow}
            bodyStyle={{ paddingTop: '16px' }}
            footer={[
                <Button key="cancel" onClick={toggleShow} style={{ width: '230px' }}>
                    Cancelar
                </Button>,
                <Button type='primary' onClick={handleChooseClose} style={{ width: '230px' }}>
                    {isCreate ? 'Confirmar' : 'Deletar'}
                </Button>
            ]}
        >
            <Select
                placeholder="Selecione um ano"
                value={tempYear || undefined}
                onChange={(value: string) => setTempYear(value)}
                style={{ width: '100%' }}
            >
                {itens()}
            </Select>

        </Modal>
    );
};

export default ModalSelectYear;